import { Navigate } from 'react-router-dom';
import { routeConfig } from '../../config/routeConfig';

function DefaultPage() {
  return <Navigate to={routeConfig.dashboard} />;
}

export default DefaultPage;
